import archivedKsefPurchaseInvoice from './archived-ksef-purchase-invoice';
import closedMonthRequest from './closed-month-request';
import closedMonth from './closed-month.js';
import declaration from './declaration';
import declarationType from './declaration-type';
import dictionary from './dictionary';
import evidenceDescriptionTemplate from './evidence-description-template';
import evidenceFromInvoiceWithoutTemplateWorkParameter from './evidence-from-invoice-without-template-work-parameter';
import evidenceSummary from './evidence-summary';
import evidenceSymfonia from './evidence-symfonia.js';
import evidence from './evidence.js';
import invoiceImport from './invoice-import.js';
import invoicePartialPayment from './invoice-partial-payment.js';
import invoice from './invoice.js';
import invoiceSentEmails from './invoice/invoice-sent-emails';
import invoiceSummary from './invoice-summary.js';
import ksefConfiguration from './ksef-configuration';
import ksefInvoices from './ksef-invoices';
import ksefPurchaseInvoice from './ksef-purchase-invoice';
import ksefPurchaseInvoiceComments from './ksef-purchase-invoice-comments';
import vehicle from './vehicle';
import workParameters from './work-parameters';
import zusDeclarations from './zus-declaration';
import zusFixedAssetSettlement from './zus-fixed-asset-settlement';

export default {
  closedMonth,
  closedMonthRequest,
  declaration,
  declarationType,
  dictionary,
  evidence,
  evidenceDescriptionTemplate,
  evidenceFromInvoiceWithoutTemplateWorkParameter,
  evidenceSymfonia,
  evidenceSummary,
  invoice,
  invoiceImport,
  invoicePartialPayment,
  invoiceSentEmails,
  invoiceSummary,
  archivedKsefPurchaseInvoice,
  ksefConfiguration,
  ksefInvoices,
  ksefPurchaseInvoice,
  ksefPurchaseInvoiceComments,
  workParameters,
  zusDeclarations,
  zusFixedAssetSettlement,
  vehicle,
};
